/**
 * @fileoverview Shared toggle and disabled-field constants for the Location section.
 */

/** Translation key for "show in profile" toggle label */
export const SHOW_IN_PROFILE_KEY = "components.contactInformation.showInProfile";

/** Color for active toggle state */
export const TOGGLE_COLOR_ACTIVE = "#1d5ae8";

/** Color for inactive toggle state */
export const TOGGLE_COLOR_INACTIVE = "#C7C8C8";

/** CSS cursor value for disabled/read-only elements */
export const CURSOR_NOT_ALLOWED = "not-allowed";
